import { render, staticRenderFns } from "./PluginActions.vue?vue&type=template&id=8b638946&"
import script from "./PluginActions.vue?vue&type=script&lang=js&"
export * from "./PluginActions.vue?vue&type=script&lang=js&"
import style0 from "./PluginActions.vue?vue&type=style&index=0&id=8b638946&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports